const getDefaultState = () => {
    return {
        action: {
            name: null,
            data: {},
        },
        scriptsLoaded: false,
        blockLoading: false,
        templatesLoaded: false,
    };
};

const App = {
    namespaced: true,

    state: getDefaultState(),
    mutations: {
        SET_SCRIPTS_LOADED: state => {
            state.scriptsLoaded = true;
        },
        SET_ACTION: (state, payload) => {
            state.action = payload;
        },
        RESET_STATE: state => {
            Object.assign(state, getDefaultState());
        },
        SET_BLOCK_LOADING: (state, payload) => {
            state.blockLoading = payload;
        },
        SET_TEMPLATES_LOADED: state => {
            state.templatesLoaded = true;
        }
    },
    actions: {
        resetState: ({ commit }) => {
            commit('RESET_STATE');
        },
        setAction: ({ commit }, payload) => {
            commit('SET_ACTION', payload);
        },
        setScriptsLoaded: ({ commit }) => {
            commit('SET_SCRIPTS_LOADED');
        },
        resetActiveIDT: ({ commit }) => {
            commit('RESET_ACTIVE_IDT');
        },
        setBlockLoading: ({ commit }, payload) => {
            commit('SET_BLOCK_LOADING', payload);
        },
        setTemplatesLoaded: ({ commit }) => {
            commit('SET_TEMPLATES_LOADED');
        },

        applyGrade: async ({ rootState, dispatch }, sourceAsset) => {
            dispatch('Loader/showProgressBar', 'indeterminate', { root: true });

            let activeImage = rootState.Projects.image;
            let assetStoreData;

            await window.lutify.storeLastState();

            if (sourceAsset.type == 'candidate') {
                assetStoreData = await window.lutify.fetchCandidate(sourceAsset);
            } else if (sourceAsset.type == 'match') {
                assetStoreData = await window.lutify.fetchMatch(sourceAsset);
            }

            let lastState = await window.lutify.fetchLastState(activeImage);
            let blocks = [...assetStoreData.blocks];
            blocks[1] = lastState.blocks[1];
            blocks[blocks.length - 1] = lastState.blocks[lastState.blocks.length - 1];

            await window.lutify.applyCompare(blocks, 'waitToLoad', false);

            if (loader.typeOfActiveMedia('raw') && assetStoreData.rawDevelopment) {
                await vm.rawDevelopment.applyData(assetStoreData.rawDevelopment);
            }

            dispatch('Loader/showProgressBar', false, { root: true });
        },
    },
    getters: {},
};

export default App;
